"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  AdvertisingMegaphone: ['advertising-megaphone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.854,14.293l-2.163-3.561a.25.25,0,0,1-.035-.149l.334-4.154a1,1,0,0,0-.76-1.052L17.182,4.39a.254.254,0,0,1-.131-.081l-2.7-3.174A1,1,0,0,0,13.069.929L9.509,3.092a.248.248,0,0,1-.15.035L5.205,2.793a1.025,1.025,0,0,0-1.052.76L3.069,8a1,1,0,0,0,1.944.474l.831-3.407a.25.25,0,0,1,.263-.189l3.5.281a1.024,1.024,0,0,0,.6-.143l3-1.82a.249.249,0,0,1,.32.052L15.79,5.914a1,1,0,0,0,.524.323l3.407.831a.25.25,0,0,1,.19.263l-.281,3.5a1,1,0,0,0,.142.6l1.821,3a.252.252,0,0,1-.052.32L18.87,17.014a1,1,0,0,0-.323.525l-.831,3.406a.25.25,0,0,1-.263.19l-3.495-.281a1,1,0,0,0-.16,1.994l4.556.366c.028,0,.054,0,.082,0a1,1,0,0,0,.97-.762l.988-4.049a.248.248,0,0,1,.081-.131l3.173-2.7A1,1,0,0,0,23.854,14.293Z', 'M.114,19.226a.5.5,0,0,0-.031.6l1.008,1.518a.5.5,0,0,0,.559.2h0l2.257-.675a.249.249,0,0,1,.28.1l.6.91A2.87,2.87,0,0,0,9.9,19.365a.249.249,0,0,1,.182-.324l4.294-.964a.249.249,0,0,1,.263.1l.078.117a.752.752,0,0,0,.626.335.743.743,0,0,0,.414-.125.751.751,0,0,0,.21-1.04L9.588,7.857a.75.75,0,1,0-1.25.83l.071.106a.249.249,0,0,1-.015.3ZM7.95,21.433a1.375,1.375,0,0,1-1.906-.385l-.268-.4a.251.251,0,0,1,.137-.378L8.146,19.6a.251.251,0,0,1,.3.139A1.375,1.375,0,0,1,7.95,21.433Z']],
  AdsWindow: ['ads-window', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,7.5a1,1,0,0,0-1,1v13a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2H15.25a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V8.5A1,1,0,0,0,23,7.5Z', 'M17.5,10.25H19a.75.75,0,0,0,0-1.5H17.5a2.16,2.16,0,0,0-2.25,2.05,3.1,3.1,0,0,0,1.841,2.579c.8.524,1.159.807,1.159,1.322,0,.3-.344.549-.75.549H16a.75.75,0,0,0,0,1.5h1.5A2.159,2.159,0,0,0,19.75,14.7a3.1,3.1,0,0,0-1.841-2.579c-.8-.524-1.159-.807-1.159-1.322C16.75,10.5,17.094,10.25,17.5,10.25Z', 'M7.5,16.75A.75.75,0,0,0,8.25,16V10.8A2.16,2.16,0,0,0,6,8.75,2.16,2.16,0,0,0,3.75,10.8V16a.75.75,0,0,0,1.5,0V14.4a.25.25,0,0,1,.25-.25h1a.25.25,0,0,1,.25.25V16A.75.75,0,0,0,7.5,16.75Zm-1-4.1h-1a.25.25,0,0,1-.25-.25V10.8c0-.3.344-.55.75-.55s.75.252.75.55v1.6A.25.25,0,0,1,6.5,12.651Z', 'M9.75,9.5V16a.75.75,0,0,0,.75.75A3.571,3.571,0,0,0,14.25,13.4V12.1A3.572,3.572,0,0,0,10.5,8.75.75.75,0,0,0,9.75,9.5Zm1.5,1.216a.251.251,0,0,1,.116-.211.248.248,0,0,1,.239-.016A1.83,1.83,0,0,1,12.75,12.1v1.3a1.829,1.829,0,0,1-1.145,1.61.249.249,0,0,1-.355-.226Z', 'M23.707,1.708A1,1,0,0,0,22.293.293L21.177,1.41a.252.252,0,0,1-.354,0L19.707.293a1,1,0,0,0-1.414,1.415l1.116,1.116a.249.249,0,0,1,0,.353L18.293,4.293a1,1,0,0,0,1.414,1.415l1.116-1.117a.252.252,0,0,1,.354,0l1.116,1.117a1,1,0,1,0,1.414-1.415L22.591,3.177a.249.249,0,0,1,0-.353Z']],
  FlyerTaken: ['flyer-taken', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.164,12.119a.25.25,0,0,0,.336-.235V2a1,1,0,0,0-1-1H1.5a1,1,0,0,0-1,1v9.689a.25.25,0,0,0,.368.221,3.452,3.452,0,0,1,4.2.733.249.249,0,0,0,.184.082.252.252,0,0,0,.185-.082,3.451,3.451,0,0,1,5.131,0,.249.249,0,0,0,.184.082.252.252,0,0,0,.185-.082,3.464,3.464,0,0,1,5.353.257.251.251,0,0,0,.179.1.463.463,0,0,0,.419-.18,2,2,0,0,1,3.228,0,.489.489,0,0,0,.772,0A2,2,0,0,1,22.5,12,1.921,1.921,0,0,1,23.164,12.119ZM8.5,7.5a1,1,0,0,1-1,1h-3a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1Zm10-1.25H12a.75.75,0,0,1,0-1.5h6.5a.75.75,0,0,1,0,1.5Z', 'M.5,22.5A.5.5,0,0,0,1,23H4a.5.5,0,0,0,.5-.5V15a2,2,0,0,0-2-2,2.04,2.04,0,0,0-.336.028A2.074,2.074,0,0,0,.5,15.107Z', 'M9.5,23a.5.5,0,0,0,.5-.5V15a2,2,0,0,0-2.336-1.972A1.962,1.962,0,0,0,6,15v7.5a.5.5,0,0,0,.5.5Z', 'M15,23a.5.5,0,0,0,.5-.5V15a2,2,0,0,0-2.336-1.972A1.962,1.962,0,0,0,11.5,15v7.5a.5.5,0,0,0,.5.5Z']],
  LaptopAnnouncement: ['laptop-announcement', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4,11.357v8a.359.359,0,0,0,.009.081.251.251,0,0,1-.09.244L1.887,21.308a.994.994,0,0,0-.369.891A1.775,1.775,0,0,0,3.5,23.857h17A1.775,1.775,0,0,0,22.482,22.2a1,1,0,0,0-.37-.891l-2.031-1.625a.251.251,0,0,1-.09-.244A.359.359,0,0,0,20,19.357v-8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,11.357Zm10,10.75H10a.75.75,0,0,1,0-1.5h4a.75.75,0,0,1,0,1.5ZM6.249,11.357h11.5a.25.25,0,0,1,.25.25v6.5a.249.249,0,0,1-.25.25H6.25a.249.249,0,0,1-.25-.25v-6.5a.248.248,0,0,1,.073-.176A.252.252,0,0,1,6.249,11.357Z', 'M19.118,3.5,23.758.92A.016.016,0,0,0,23.766.9a.485.485,0,0,0-.133-.253A.348.348,0,0,1,23.6.6,1.078,1.078,0,0,0,22.571.143H15.429A1.078,1.078,0,0,0,14.405.6a.3.3,0,0,1-.038.048A.489.489,0,0,0,14.234.9a.018.018,0,0,0,.008.019L18.889,3.5A.222.222,0,0,0,19.118,3.5Z', 'M14.214,5.592c0,.887.363,1.265,1.215,1.265h7.142c.852,0,1.215-.378,1.215-1.265V2.472a.251.251,0,0,0-.371-.219L19.6,4.37a1.232,1.232,0,0,1-1.2,0L14.585,2.254a.25.25,0,0,0-.371.218Z', 'M.214,5.592c0,.887.363,1.265,1.215,1.265H8.571c.852,0,1.215-.378,1.215-1.265V2.472a.251.251,0,0,0-.371-.219L5.6,4.37a1.232,1.232,0,0,1-1.2,0L.585,2.254a.25.25,0,0,0-.371.218Z', 'M5.118,3.5,9.758.92A.016.016,0,0,0,9.766.9.485.485,0,0,0,9.633.648.348.348,0,0,1,9.6.6,1.078,1.078,0,0,0,8.571.143H1.429A1.078,1.078,0,0,0,.405.6.3.3,0,0,1,.367.648.489.489,0,0,0,.234.9.018.018,0,0,0,.242.92L4.889,3.5A.222.222,0,0,0,5.118,3.5Z']],
  ShoppingVoucherMail: ['shopping-voucher-mail', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.742,11.063a.5.5,0,0,0-.506.013l-2.353,1.471a.25.25,0,0,1-.383-.212V1.963A1.984,1.984,0,0,0,18.5,0H5.5a1.984,1.984,0,0,0-2,1.963V12.335a.25.25,0,0,1-.383.212L.765,11.077A.5.5,0,0,0,0,11.5V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V11.5A.5.5,0,0,0,23.742,11.063ZM20.561,20.5a.752.752,0,0,1-1.059.062l-4.216-3.748a.254.254,0,0,0-.166-.063H8.88a.254.254,0,0,0-.166.063L4.5,20.561a.75.75,0,1,1-1-1.121l4.145-3.685a.248.248,0,0,0,.083-.208.252.252,0,0,0-.117-.191l-2-1.247A.25.25,0,0,1,5.5,13.9V3a1,1,0,0,1,1-1l11-.032a1,1,0,0,1,1,1V13.9a.25.25,0,0,1-.117.212l-2,1.247a.252.252,0,0,0-.117.191.248.248,0,0,0,.083.208L20.5,19.44A.75.75,0,0,1,20.561,20.5Z', 'M16.256,3.8a.751.751,0,0,0-.961.449l-.3.841a.249.249,0,0,1-.236.165H9a1.243,1.243,0,0,0-1.043.562,1.228,1.228,0,0,0-.126,1.131l0,.014L8.919,9.983,8.925,10a1.245,1.245,0,0,0,1.146.752h3.578a1.256,1.256,0,0,0,1.176-.822L16.7,4.757A.75.75,0,0,0,16.256,3.8Z', 'M9.000 12.500 A1.000 1.000 0 1 0 11.000 12.500 A1.000 1.000 0 1 0 9.000 12.500 Z', 'M13.000 12.500 A1.000 1.000 0 1 0 15.000 12.500 A1.000 1.000 0 1 0 13.000 12.500 Z']],
  Invitation: ['invitation', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.25,4a.75.75,0,0,0-.75-.75h-6a.75.75,0,0,0,0,1.5h6A.749.749,0,0,0,20.25,4Z', 'M19.5,6.25h-3a.75.75,0,0,0,0,1.5h3a.75.75,0,0,0,0-1.5Z', 'M7.75,3A3.25,3.25,0,1,0,11,6.25,3.254,3.254,0,0,0,7.75,3Zm0,5A1.75,1.75,0,1,1,9.5,6.25,1.752,1.752,0,0,1,7.75,8Z', 'M13.25,24h6.5a.25.25,0,0,0,.25-.25V19.523a.228.228,0,0,1,0-.045l.782-4.3A.219.219,0,0,1,21,15a2.02,2.02,0,0,0,2-2V2a2,2,0,0,0-2-2H3A2,2,0,0,0,1,2V13a2,2,0,0,0,2,2H6.793a.249.249,0,0,1,.25.258C7.022,15.993,7,16.89,7,17.5c0,1.118,1.368,1.317,2,1a4.142,4.142,0,0,0,1.546-1.827.248.248,0,0,0,.017-.048l.359-1.436A.25.25,0,0,1,11.165,15h.515a.252.252,0,0,1,.243.311L11.5,17a5.731,5.731,0,0,0,0,3,9.045,9.045,0,0,0,1.431,1.929A.249.249,0,0,1,13,22.1V23.75A.25.25,0,0,0,13.25,24ZM12,10.542V12.75a.249.249,0,0,1-.25.25H3.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,3.5,2h17a.5.5,0,0,1,.5.5v10a.5.5,0,0,1-.5.5H16.25a.249.249,0,0,1-.25-.25V10.542C16,10.042,16,8,14,8S12,10.042,12,10.542Z']],
  LaptopAnnouncement1: ['laptop-announcement-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.6,23.963H21.4a1.6,1.6,0,0,0,1-2.849l-2.486-1.99a.249.249,0,0,1-.083-.27,2.057,2.057,0,0,0,.1-.616v-6.6a2.1,2.1,0,0,0-2.1-2.1H5.172a2.1,2.1,0,0,0-2.1,2.1v6.6a2.045,2.045,0,0,0,.1.615.25.25,0,0,1-.083.27L.6,21.114a1.6,1.6,0,0,0,1,2.849Zm11.824-1.675H9.572a.75.75,0,0,1,0-1.5h3.85a.75.75,0,0,1,0,1.5Zm-8.35-10.25a.5.5,0,0,1,.5-.5h11.85a.5.5,0,0,1,.5.5v5.8a.5.5,0,0,1-.5.5H5.572a.5.5,0,0,1-.5-.5Z', 'M0,6.538a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V2.246a.25.25,0,0,0-.359-.225L5.034,4.239a.5.5,0,0,1-.433,0L.361,2.2a.249.249,0,0,0-.241.014A.247.247,0,0,0,0,2.424Z', 'M4.709,3.181a.25.25,0,0,0,.217,0L9.731.869A.251.251,0,0,0,9.837.513.972.972,0,0,0,9,.038H1A.982.982,0,0,0,.076.706.251.251,0,0,0,.2,1.014Z', 'M23,.038H15a.982.982,0,0,0-.927.668.251.251,0,0,0,.128.308l4.5,2.167a.25.25,0,0,0,.217,0L23.731.869a.251.251,0,0,0,.106-.356A.972.972,0,0,0,23,.038Z', 'M23.644,2.021l-4.61,2.218a.5.5,0,0,1-.433,0L14.361,2.2A.25.25,0,0,0,14,2.424V6.538a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V2.246a.25.25,0,0,0-.359-.225Z']],
  Billboard: ['billboard', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17,22a1,1,0,0,0,1-1V17.25a.25.25,0,0,1,.25-.25H22.5a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H20a.25.25,0,0,0-.25.25V3.5a.25.25,0,0,0,.25.25h1a.75.75,0,0,1,0,1.5H17a.75.75,0,0,1,0-1.5h1a.25.25,0,0,0,.25-.25V2.25A.25.25,0,0,0,18,2H13a.25.25,0,0,0-.25.25V3.5a.25.25,0,0,0,.25.25h1a.75.75,0,0,1,0,1.5H10a.75.75,0,0,1,0-1.5h1a.25.25,0,0,0,.25-.25V2.25A.25.25,0,0,0,11,2H6a.25.25,0,0,0-.25.25V3.5A.25.25,0,0,0,6,3.75H7a.75.75,0,0,1,0,1.5H3a.75.75,0,0,1,0-1.5H4a.25.25,0,0,0,.25-.25V2.25A.25.25,0,0,0,4,2H1.5a1,1,0,0,0-1,1V16a1,1,0,0,0,1,1H5.75a.25.25,0,0,1,.25.25V21a1,1,0,0,0,2,0V17.25A.25.25,0,0,1,8.25,17h7.5a.25.25,0,0,1,.25.25V21A1,1,0,0,0,17,22Z']],
  PromoMail: ['promo-mail', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14,6.5a1,1,0,0,0,1-1V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V17.5a2,2,0,0,0,2,2h.5a1,1,0,0,0,0-2A.5.5,0,0,1,2,17V2.5A.5.5,0,0,1,2.5,2h10a.5.5,0,0,1,.5.5v3A1,1,0,0,0,14,6.5Z', 'M5,4.25a.75.75,0,0,0-1.5,0v9a.75.75,0,0,0,1.5,0Z', 'M6.000 5.000 A1.500 1.500 0 1 0 9.000 5.000 A1.500 1.500 0 1 0 6.000 5.000 Z', 'M14.500 12.500 A1.500 1.500 0 1 0 17.500 12.500 A1.500 1.500 0 1 0 14.500 12.500 Z', 'M22,8H10a2,2,0,0,0-2,2v2.5a1,1,0,0,0,2,0v-2a.5.5,0,0,1,.5-.5h11a.5.5,0,0,1,.5.5v6a.5.5,0,0,1-.5.5h-2a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2V10A2,2,0,0,0,22,8Z', 'M5,17v5a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V17a2,2,0,0,0-2-2H7A2,2,0,0,0,5,17Zm10,4.5a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5V19.577a.25.25,0,0,1,.343-.232L10.722,20.7a.756.756,0,0,0,.556,0l3.379-1.352a.25.25,0,0,1,.343.232ZM7.5,17h7a.5.5,0,0,1,.5.5.137.137,0,0,1-.086.127l-3.821,1.529a.259.259,0,0,1-.186,0L7.086,17.627A.137.137,0,0,1,7,17.5.5.5,0,0,1,7.5,17Z']]
};
exports["default"] = _default;